import React from 'react';

import { generalConstants } from '../constants';
import { TextInput, TextArea } from '../components';

class ImageBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.refs.fileUploader.click();
  }

  render() {
    const imgStyle = {
      maxWidth: '100%',
      maxHight: '100%'
    };

    const {
      image,
      image_onChange,
      title_value,
      title_onChange,
      description_value,
      description_onChange,
      sort_up,
      sort_down,
      clear
    } = this.props;

    return (
      <div className="uploader-item" style={{ minHeight: '210px'}}>
        <ul className="uploader-actions clearfix">
          <li>
            <a href="" onClick={sort_up}>
              <i className="fa fa-caret-up" />
            </a>
          </li>
          <li>
            <a href="" onClick={sort_down}>
              <i className="fa fa-caret-down" />
            </a>
          </li>
          <li>
            <a href="" className="uploader-action-delete" onClick={clear}>
              <i className="fal fa-trash-alt" />
            </a>
          </li>
        </ul>
        <input
          type="file"
          ref="fileUploader"
          name="file"
          style={{ display: 'none' }}
          onChange={image_onChange}
        />
        <button
          className={'uploader-img' + (image.image.data ? ' uploader-img-filled' : '')}
          onClick={this.handleClick}
        >
          {image.image.data ? (
            <img
              src={generalConstants.BASE_URL + image.image.data.url}
              style={imgStyle}
              className="img-responsive"
              alt="Image Uploaded"
            />
          ) : (
            <div className="icon">
              <i className="fa fa-arrow-circle-o-up" />
            </div>
          )}
        </button>
        <div className="uploader-form" role="form">
        {
          title_onChange && <TextInput
            input_label="Title"
            input_placeholder="Enter Title"
            input_name="title"
            input_type="text"
            input_onChange={title_onChange}
            input_value={title_value}
          />
        }{
          description_onChange && <TextArea
            input_label="Description"
            input_placeholder="Enter Description"
            input_name="description"
            input_type="text"
            input_onChange={description_onChange}
            input_value={description_value}
            input_rows={4}
          />
        }
        </div>
      </div>
    );
  }
}

export { ImageBox };



// WEBPACK FOOTER //
// ./src/components/ImageBox.js